import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase,
  InspectionVolumeCase
} from '../inspection-cases';

export class GasExtinguishingSystemDto extends InspectionCase {
  basedOnPrEngineerSystem?: InspectionValueCase;
  computerRun?: InspectionCase;
  tankMadeOf?: InspectionValueCase;
  containerModel?: InspectionValueCase;
  gasWeight?: InspectionValueCase;
  pipeDesignType?: InspectionValueCase;
  modelDispersionNozzledDesign?: InspectionValueCase;
  dispersalNostrilsCount?: InspectionValueCase;
  boardDetailsOrProtectedSpace?: InspectionValueCase;
  electricalPowerUnitMatchDiscoveryHub?: InspectionCase;
  siteRiskLevel?: InspectionValueCase; // Class A | B | C
  classificationType?: InspectionValueCase; // חשמל – C | נוזלים – B | חומרים דליקים - A
  boardDimensions?: InspectionVolumeCase;
}

export class GasExtinguishingSystem extends GasExtinguishingSystemDto {
  constructor(
    data: GasExtinguishingSystemDto = { title: 'מערכת כיבוי באמצעות גז' }
  ) {
    super(data);
    this.basedOnPrEngineerSystem = new InspectionValueCase({
      ...data.basedOnPrEngineerSystem,
      title: `המערכת מבוססת על מערכת Pre-Engineer של חברת`
    });
    this.computerRun = new InspectionCase({
      ...data.computerRun,
      title: `התקבלה הרצת מחשב כולל סכמת מהלכי צנרת`
    });
    this.tankMadeOf = new InspectionValueCase({
      ...data.tankMadeOf,
      title: `תוצרת המיכל`
    });
    this.containerModel = new InspectionValueCase({
      ...data.containerModel,
      title: `דגם המיכל`
    });
    this.gasWeight = new InspectionValueCase({
      ...data.gasWeight,
      title: `משקל הגז`
    });
    this.pipeDesignType = new InspectionValueCase({
      ...data.pipeDesignType,
      title: `תוכננה צנרת מסוג`
    });
    this.modelDispersionNozzledDesign = new InspectionValueCase({
      ...data.modelDispersionNozzledDesign,
      title: `תוכננו נחיר פיזור ,דגם`
    });
    this.dispersalNostrilsCount = new InspectionValueCase({
      ...data.dispersalNostrilsCount,
      title: `מס' נחירי הפיזור שתוכננו`
    });
    this.boardDetailsOrProtectedSpace = new InspectionValueCase({
      ...data.boardDetailsOrProtectedSpace,
      title: `פרטי הלוח / החלל המוגן`
    });
    this.electricalPowerUnitMatchDiscoveryHub = new InspectionCase({
      ...data.electricalPowerUnitMatchDiscoveryHub,
      title: `קיימת התאמה בין יחידת ההפעלה החשמלית של הכיבוי לרכזת הגילוי`
    });
    this.siteRiskLevel = new InspectionValueCase({
      ...data.siteRiskLevel,
      title: `האתר מסווג כדרגת סיכון : Class A / B / C`
    });
    this.classificationType = new InspectionValueCase({
      ...data.classificationType,
      title: `סמן את הסיווג המתאים`
    });
    this.boardDimensions = new InspectionVolumeCase({
      ...data.boardDimensions,
      title: `ממדי לוח / חדר החשמל / תקשורת , הינם`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.basedOnPrEngineerSystem.isApplicable ||
        this.basedOnPrEngineerSystem.isPassed) &&
        (!this.computerRun.isApplicable || this.computerRun.isPassed) &&
        (!this.tankMadeOf.isApplicable || this.tankMadeOf.isPassed) &&
        (!this.containerModel.isApplicable || this.containerModel.isPassed) &&
        (!this.gasWeight.isApplicable || this.gasWeight.isPassed) &&
        (!this.pipeDesignType.isApplicable || this.pipeDesignType.isPassed) &&
        (!this.modelDispersionNozzledDesign.isApplicable ||
          this.modelDispersionNozzledDesign.isPassed) &&
        (!this.dispersalNostrilsCount.isApplicable ||
          this.dispersalNostrilsCount.isPassed) &&
        (!this.boardDetailsOrProtectedSpace.isApplicable ||
          this.boardDetailsOrProtectedSpace.isPassed) &&
        (!this.electricalPowerUnitMatchDiscoveryHub.isApplicable ||
          this.electricalPowerUnitMatchDiscoveryHub.isPassed) &&
        (!this.siteRiskLevel.isApplicable || this.siteRiskLevel.isPassed) &&
        (!this.classificationType.isApplicable ||
          this.classificationType.isPassed) &&
        (!this.boardDimensions.isApplicable || this.boardDimensions.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.basedOnPrEngineerSystem.getNotes(),
      ...this.computerRun.getNotes(),
      ...this.tankMadeOf.getNotes(),
      ...this.containerModel.getNotes(),
      ...this.gasWeight.getNotes(),
      ...this.pipeDesignType.getNotes(),
      ...this.modelDispersionNozzledDesign.getNotes(),
      ...this.dispersalNostrilsCount.getNotes(),
      ...this.boardDetailsOrProtectedSpace.getNotes(),
      ...this.electricalPowerUnitMatchDiscoveryHub.getNotes(),
      ...this.siteRiskLevel.getNotes(),
      ...this.classificationType.getNotes(),
      ...this.boardDimensions.getNotes()
    ];
  }
}
